import React, { FC } from 'react';
import { useHotkeys } from 'react-hotkeys-hook';

import { Checkbox, PhaseOptionContainer } from './PhaseOption.style';

interface PhaseOptionProps {
  phaseLabel: any;
  isActive: any;
  isLabeled: any;
  handlePhaseOptionOnClick: any;
}

const PhaseOption: FC<PhaseOptionProps> = props => {
  const { phaseLabel, isActive, isLabeled, handlePhaseOptionOnClick } = props;
  const hotkey = phaseLabel?.phaseClass?.[0];
  const label = phaseLabel?.phaseClass;

  useHotkeys(hotkey, event => {
    event?.preventDefault();
    handlePhaseOptionOnClick();
  });

  return (
    <PhaseOptionContainer isSelected={isActive} onClick={handlePhaseOptionOnClick}>
      <Checkbox checked={isLabeled} readOnly />({hotkey}) {label}
    </PhaseOptionContainer>
  );
};

export default PhaseOption;
